import { render, staticRenderFns } from "./CompanyBoardPost.vue?vue&type=template&id=34486ee6"
import script from "./CompanyBoardPost.vue?vue&type=script&lang=js"
export * from "./CompanyBoardPost.vue?vue&type=script&lang=js"
import style0 from "./CompanyBoardPost.vue?vue&type=style&index=0&id=34486ee6&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports